/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SpecialityValidityResultModel } from '../../models/speciality-validity-result-model';

export interface AnonymousFhirIdSpecialityValidityGet$Params {
  fhirId: string;
}

export function anonymousFhirIdSpecialityValidityGet(http: HttpClient, rootUrl: string, params: AnonymousFhirIdSpecialityValidityGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<Array<SpecialityValidityResultModel>>> {
  const rb = new RequestBuilder(rootUrl, anonymousFhirIdSpecialityValidityGet.PATH, 'get');
  if (params) {
    rb.path('fhirId', params.fhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<Array<SpecialityValidityResultModel>>;
    })
  );
}

anonymousFhirIdSpecialityValidityGet.PATH = '/Anonymous/{fhirId}/SpecialityValidity';
